import i18n from 'i18next';
import LanguageDetector  from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import fr from './fr/fr.json';
import en from './en/en.json';

const options = {
  order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
  caches: ['sessionStorage'],
}
i18n
  .use(LanguageDetector )
  .use(initReactI18next)
  .init({
    resources: {
      fr,
      en,
    },
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    detection: options
  });

export default i18n;
